var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colspan,
          "get-action": _vm.queryApi,
          "auto-fetch": false,
          rules: _vm.queryRules,
          "btn-search-style": _vm.trialSearchButtonStyle,
          "before-reset-search": _vm.beforeResetSearch,
          "before-query-search": _vm.beforeQuerySearch,
          serial: false,
          selection: false,
          "is-list": true,
          height: _vm.trialTableHeight,
        },
        on: {
          afterFetchData: _vm.afterFetchData,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.feeItem"),
                          prop: "feeItems",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            multiple: "",
                            "collapse-tags": "",
                            placeholder: _vm.$t("QuotationCenter.feeItem"),
                            "option-list": _vm.QUOTATION_FEE_ITEM,
                          },
                          model: {
                            value: _vm.queryParams.feeItems,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "feeItems", $$v)
                            },
                            expression: "queryParams.feeItems",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.components.country"),
                          prop: "country",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCenter.components.country"
                            ),
                            "option-list": _vm.COUNTRY_NAME_AND_TWOCODE,
                          },
                          model: {
                            value: _vm.queryParams.country,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "country", $$v)
                            },
                            expression: "queryParams.country",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.components.province"),
                          prop: "state",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCenter.components.province"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "state", $$v)
                            },
                            expression: "queryParams.state",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.components.city"),
                          prop: "city",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCenter.components.city"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.city,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "city", $$v)
                            },
                            expression: "queryParams.city",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.components.postcode"),
                          prop: "postCode",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCenter.components.postcode"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.postCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "postCode", $$v)
                            },
                            expression: "queryParams.postCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.supplier"),
                          prop: "supplierCode",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: _vm.$t("QuotationCenter.supplier"),
                          },
                          model: {
                            value: _vm.$route.query.supplierName,
                            callback: function ($$v) {
                              _vm.$set(_vm.$route.query, "supplierName", $$v)
                            },
                            expression: "$route.query.supplierName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.logisticsChannel"),
                          prop: "logisticsChannelCode",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: _vm.$t(
                              "QuotationCenter.logisticsChannel"
                            ),
                          },
                          model: {
                            value: _vm.$route.query.logisticsChannelName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.$route.query,
                                "logisticsChannelName",
                                $$v
                              )
                            },
                            expression: "$route.query.logisticsChannelName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.packageType"),
                          prop: "packageType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCenter.packageType"),
                            "option-list": _vm.QUOTATION_PACKAGE_TYPE,
                          },
                          model: {
                            value: _vm.queryParams.packageType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "packageType", $$v)
                            },
                            expression: "queryParams.packageType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "QuotationCenter.components.declaredCurrency"
                          ),
                          prop: "currency",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCenter.components.declaredCurrency"
                            ),
                            "option-list": _vm.currencyList,
                          },
                          model: {
                            value: _vm.queryParams.currency,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "currency", $$v)
                            },
                            expression: "queryParams.currency",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.amount"),
                          prop: "amount",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("QuotationCenter.amount"),
                          },
                          model: {
                            value: _vm.queryParams.amount,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "amount", $$v)
                            },
                            expression: "queryParams.amount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCenter.billingType"),
                          prop: "billingType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            multiple: "",
                            placeholder: _vm.$t("QuotationCenter.billingType"),
                            "option-list": _vm.QUOTATION_BILLING_TYPE,
                          },
                          on: { change: _vm.handleBillingTypeChange },
                          model: {
                            value: _vm.queryParams.billingType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "billingType", $$v)
                            },
                            expression: "queryParams.billingType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "weight" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("span", { staticClass: "trial-required-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "QuotationCenter.components.actualWeight"
                                )
                              )
                            ),
                          ]),
                        ]),
                        _c(
                          "el-input",
                          {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCenter.components.actualWeight"
                              ),
                            },
                            model: {
                              value: _vm.queryParams.weight,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "weight", $$v)
                              },
                              expression: "queryParams.weight",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("kg")])],
                          2
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "length" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(1),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.length")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "el-input",
                          {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCenter.components.length"
                              ),
                            },
                            model: {
                              value: _vm.queryParams.length,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "length", $$v)
                              },
                              expression: "queryParams.length",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("cm")])],
                          2
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "width" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(1),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.width")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "el-input",
                          {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCenter.components.width"
                              ),
                            },
                            model: {
                              value: _vm.queryParams.width,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "width", $$v)
                              },
                              expression: "queryParams.width",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("cm")])],
                          2
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "height" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(1),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.height")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c(
                          "el-input",
                          {
                            attrs: {
                              placeholder: _vm.$t(
                                "QuotationCenter.components.height"
                              ),
                            },
                            model: {
                              value: _vm.queryParams.height,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryParams, "height", $$v)
                              },
                              expression: "queryParams.height",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("cm")])],
                          2
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "PalletsNum" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(2),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.Pallets")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: {
                            disabled: !_vm.isBillingTypeSelected(2),
                            placeholder: _vm.$t(
                              "QuotationCenter.components.Pallets"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.PalletsNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "PalletsNum", $$v)
                            },
                            expression: "queryParams.PalletsNum",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "TicketsNum" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(3),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.Tickets")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: {
                            disabled: "",
                            placeholder: _vm.$t(
                              "QuotationCenter.components.Tickets"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.TicketsNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "TicketsNum", $$v)
                            },
                            expression: "queryParams.TicketsNum",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "HoursNum" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(4),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.Hours")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: {
                            disabled: !_vm.isBillingTypeSelected(4),
                            placeholder: _vm.$t(
                              "QuotationCenter.components.Hours"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.HoursNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "HoursNum", $$v)
                            },
                            expression: "queryParams.HoursNum",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "ItemsNum" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(5),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.Items")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: {
                            disabled: !_vm.isBillingTypeSelected(5),
                            placeholder: _vm.$t(
                              "QuotationCenter.components.Items"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.ItemsNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "ItemsNum", $$v)
                            },
                            expression: "queryParams.ItemsNum",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colspan } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "TimesNum" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c(
                            "span",
                            {
                              class: {
                                "trial-required-label":
                                  _vm.isBillingTypeSelected(6),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("QuotationCenter.components.Times")
                                )
                              ),
                            ]
                          ),
                        ]),
                        _c("el-input", {
                          attrs: {
                            disabled: !_vm.isBillingTypeSelected(6),
                            placeholder: _vm.$t(
                              "QuotationCenter.components.Times"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.TimesNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "TimesNum", $$v)
                            },
                            expression: "queryParams.TimesNum",
                          },
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c("BjFrontendExport", {
                      attrs: {
                        icon: "el-icon-download",
                        plain: "",
                        "label-list": _vm.exportLabelList,
                        rows: _vm.displayedRows || [],
                        "file-name":
                          _vm.$t("QuotationCenter.trialCalculation") + ".csv",
                        "empty-text": _vm.$t("table.emptyText"),
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col) {
                  return [
                    _c("el-table-column", {
                      key: col.prop,
                      attrs: {
                        prop: col.prop,
                        label: col.label,
                        width: col.width || "auto",
                        sortable: col.sortable || false,
                        align: "center",
                        "class-name": "item",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                col.prop === "feeItem"
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.QUOTATION_FEE_ITEM.bjGet(
                                              row.feeItem
                                            )
                                          )
                                        )
                                      ),
                                    ]
                                  : col.prop === "packageType"
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.QUOTATION_PACKAGE_TYPE.bjGet(
                                              row.packageType
                                            )
                                          )
                                        )
                                      ),
                                    ]
                                  : col.prop === "chargeUnit"
                                  ? [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            _vm.QUOTATION_CHARGE_UNIT.bjGet(
                                              row.billingType
                                            )
                                          )
                                        )
                                      ),
                                    ]
                                  : col.prop === "quotationAmount"
                                  ? [
                                      _vm._v(
                                        _vm._s(row.quotationAmount) +
                                          " " +
                                          _vm._s(row.quotationCurrency)
                                      ),
                                    ]
                                  : col.prop === "standardAmount"
                                  ? [
                                      _vm._v(
                                        _vm._s(row.standardAmount) +
                                          " " +
                                          _vm._s(row.standardCurrency)
                                      ),
                                    ]
                                  : [_vm._v(_vm._s(row[col.prop]))],
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "paginationBottom",
            fn: function () {
              return [
                _c("div", { staticClass: "trial-total" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("QuotationCenter.components.totalAmount")) +
                        ":"
                    ),
                  ]),
                  _c("strong", [_vm._v(_vm._s(_vm.totalAmountText))]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }